<template>
  <div>
    <div class="d-flex justify-end sticky to-header">
      <v-btn
        v-if="hasRight('GROUP_WRITE')"
        v-bind="$config.buttonAttrs.floating"
        :to="{ name: 'NewGroup' }"
        title="Hozzáadás"
      >
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </div>

    <h1 class="py-6">Csoportok</h1>

    <v-expansion-panels class="mb-4" :mandatory="!!Object.values(search).find((e) => e !== '')">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span>
            <v-icon left>mdi-filter</v-icon>
            Szűrés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2">
            <v-col :cols="12" :sm="4" :md="3">
              <v-masked-text-field
                v-model="search.name"
                @input="searchEventHandler"
                label="Megnevezés"
                clearable
                hide-details
                dense
                :mask="$config.inputMasks.name"
              />
            </v-col>
            <v-col :cols="12" :sm="4" :md="3">
              <v-autocomplete
                label="Típus"
                v-model="search.type_id"
                @change="searchEventHandler"
                item-text="name"
                item-value="id"
                hide-details
                dense
                :items="groupTypes"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card :loading="loading">
      <v-data-table
        :headers="dataTable.headers"
        :items="dataTable.items"
        :server-items-length="dataTable.itemsLength"
        :options.sync="dataTable.options"
        :footer-props="$config.dataTableFooterProps"
      >
        <template #[`item.actions`]="{ item }">
          <v-btn
            v-if="hasRight('GROUP_WRITE')"
            text
            fab
            small
            dark
            color="secondary"
            class="rounded-sm m-2"
            :to="{ name: 'GroupEditor', params: { id: item.element_id } }"
            title="Szerkesztés"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="hasRight('GROUP_WRITE')"
            text
            fab
            small
            dark
            color="secondary"
            class="rounded-sm m-2"
            @click="deleteGroup(item)"
            title="Törlés"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { dataTablePage } from '@/mixins';

export default {
  mixins: [dataTablePage],

  data() {
    return {
      routeName: 'GroupList',
      fetchItems: this.fetchGroups,
      dataTable: {
        options: {
          sortBy: ['name'],
        },
        headers: [
          { text: 'Megnevezés', value: 'name' },
          { text: 'Típus', value: 'type_name', sortable: false },
          { text: '', value: 'actions', sortable: false, align: 'end' },
        ],
      },
      search: {
        name: '',
        type_id: 0,
      },
      groupTypes: [
        {
          name: '- összes -',
          id: 0,
        }
      ],
      searchTimeout: null,
    };
  },

  async mounted() {
    try {
      const response = await this.$http.get('group-types/list');
      this.groupTypes = [ ...this.groupTypes,  ...response.group_types ];
    } catch (e) {
      console.error(e);
    }
  },

  methods: {
    parseSearchQueries() {
      return {
        name: this.$route.query.name,
        type_id: this.$route.query.type_id,
      };
    },

    async fetchGroups() {
      this.loading = true;
      try {
        const data = JSON.parse(JSON.stringify(this.search));
        data.sort_by = this.options.sortBy || [''];
        data.sort_desc = this.options.sortDesc || [false];
        const response = await this.$http.post('groups/list', this.options);
        this.dataTable.items = response.groups;
        this.dataTable.itemsLength = response.groups_count;
        this.dataTable.options.page = Number(this.$route.query.page) || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    async deleteGroup(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `<b>${item.name}</b> csoport törlésére készül!<br>Folytatja?`,
        title: 'Figyelem',
      });

      if (!confirm) return;

      try {
        const response = await this.$http.get(`groups/delete/${item.element_id}`);
        this.fetchGroups();
        if (response.status === 'OK') {
          this.$dialog.notify.info('A csoport törölve');
        }
      } catch (e) {
        console.error(e);
      }
    },
  },

  computed: {
    searchQueries() {
      return {
        name: this.search.name || '',
        type_id: this.search.type_id || '',
      };
    },
  },
};
</script>
